import { getBridge } from '@/platform';

/**
 * Что мессенджер передал при запуске.
 *
 * Нужно там же, где вход и ломается: без подписанных данных приложение дальше
 * экрана ошибки не пускает, а причина у каждого клиента своя — у одного нет
 * свойства моста, у другого параметры лежат в адресе под другими именами.
 * Поэтому сводка собрана отдельно от экрана наладки: тот доступен только после
 * успешного входа.
 *
 * Показываются имена параметров и длины значений, но не сами значения: там
 * подпись и данные пользователя.
 */
export function describeLaunchData(): string {
  const bridge = getBridge();
  const initData = bridge.getInitData();
  const params = new URLSearchParams(initData);

  const lines = [
    `платформа: ${bridge.id} (${bridge.name})`,
    `данные запуска: ${initData ? `${initData.length} символов` : 'отсутствуют'}`,
    `подпись hash: ${params.get('hash') ? 'есть' : 'нет'}`,
    `пользователь: ${params.get('user') ? 'есть' : 'нет'}`,
    `ключи: ${[...params.keys()].join(', ') || '—'}`,
    `мост: ${describeGlobals()}`,
    `адрес #: ${describePart(window.location.hash.replace(/^#/, ''))}`,
    `адрес ?: ${describePart(window.location.search.replace(/^\?/, ''))}`,
  ];

  return lines.join('\n');
}

/**
 * Состав части адреса: имена параметров и длины значений.
 *
 * Именно по именам видно, под каким ключом клиент прислал подпись — без этого
 * приложение не знает, где её искать, а показывать значения нельзя.
 */
function describePart(raw: string): string {
  if (!raw) return 'пусто';

  const entries = [...new URLSearchParams(raw).entries()];
  const named = entries.filter(([key]) => key && !key.startsWith('{'));

  if (named.length === 0) return `${raw.length} симв., без параметров: ${raw.slice(0, 40)}…`;

  return named.map(([key, value]) => `${key}(${value.length})`).join(', ');
}

/** Какие объекты мессенджеров есть на странице: по ним выбирается мост. */
function describeGlobals(): string {
  const found = [
    window.Telegram?.WebApp ? 'Telegram.WebApp' : null,
    window.WebApp ? `WebApp${window.WebApp.initData ? '' : ' (без данных запуска)'}` : null,
    window.MAX?.WebApp ? 'MAX.WebApp' : null,
    window.maxWebApp ? 'maxWebApp' : null,
  ].filter(Boolean);

  return found.length > 0 ? found.join(', ') : 'не найден';
}
